import React from 'react';
import { ReactNode } from 'react';

interface Props {
  tabId: string;
  children: ReactNode;
  isShown: boolean;
  classNames?: string;
}

export const CustomTabPanel = ({
  children,
  tabId,
  isShown,
  classNames = ''
}: Props) => {
  return (
    <div
      hidden={!isShown}
      id={`tabpanel-${tabId}`}
      className={`custom-tab-panel ${classNames}`}
    >
      {children}
    </div>
  );
};
